import { Box, Grid, Button } from "@mui/material";
import { load, remove } from "../../constants/storage";
import { FC, useState, useEffect } from "react";
import { H3, Small, Tiny, H1 } from "../../components/Typography";
import SettingsBackupRestoreOutlinedIcon from "@mui/icons-material/SettingsBackupRestoreOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { getGoldCoins } from "../../redux/actions/GoldSilverAction";
import { useAppDispatch } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import DashboardNavbar from "../../components/DashboardNavbar";
import InsertDots from "../../constants/InsertDots";
const GoldCoin: FC = () => {
  let navigate = useNavigate();
  const [selected, setSelected] = useState<any>(null);
  const [count, setCount] = useState(0);
  const [goldCoins, setGoldCoinsData] = useState([]);
  const dispatch = useAppDispatch();
  const [selectedGridRef, setSelectedGridRef] =
    useState<React.RefObject<HTMLDivElement> | null>(null);
  useEffect(() => {
    checkToken();
  }, []);
  useEffect(() => {
    if (selected && selectedGridRef?.current) {
      selectedGridRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selected, selectedGridRef]);
  const handleGridClick = (item: any) => {
    setSelected(item);
  };
  const setRef = (item: any, ref: React.RefObject<HTMLDivElement>) => {
    if (selected === item) {
      setSelectedGridRef(ref);
    }
  };

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getCoins();
    }
  };

  const getCoins = async () => {
    let token = await load("token");
    dispatch(getGoldCoins(token))
      .then(async (response: any) => {
        if (response.statusCode === 200) {
          setGoldCoinsData(response.data);
          // setSelected(response.data[0]);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const handleIncrement = () => {
    setCount(count + 1);
  };
  const onPress = () => {
    // navigate("/coinpriceBreakup");
    navigate("/coinpriceBreakup", {
      state: {
        screenName: "GoldCoin",
        selected: selected,
      },
    });
  };
  const handleDecrement = () => {
    if (count === 0) {
      return;
    } else {
      setCount(count - 1);
    }
  };
  return (
    <>
      <DashboardNavbar />
      <Box
        sx={{
          background: "#F6F6F6",
          pl: {
            md: 10,
            xs: 2,
            sm: 2,
          },
          pr: {
            md: 10,
            xs: 2,
            sm: 2,
          },
          pb: 2,
          pt: 2,
        }}
      >
        <H3
          sx={{
            fontFamily: "'Poppins', sans-serif",
            pt: 2,
          }}
        >
          Coins Collection
        </H3>
        <Grid
          xs={12}
          md={12}
          sx={{
            display: { xs: "none", sm: "flex", md: "flex" },
            flexDirection: {
              md: "row",
              xs: "column",
            },
            width: "100%",
          }}
        >
          <Grid
            xs={12}
            md={5}
            sx={{
              display: "flex",
              flexDirection: "column",
              width: {
                md: "50%",
                xs: "100%",
              },
            }}
          >
            <Grid
              sx={{
                pb: 2,
                pt: 2,
                justifyContent: "space-between",
                display: "flex",

                width: "100%",
              }}
            >
              {goldCoins.slice(0, 3).map((item: any, index: any) => (
                <Grid
                  sx={{
                    width: {
                      md: "28%",
                      xs: "30%",
                      sm: "30%",
                    },
                    cursor: "pointer",
                    background:
                      selected?.descriptions === item?.descriptions
                        ? "#FFF3DB"
                        : "#fff",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    display: "flex",
                    textAlign: "center",
                    borderRadius: 2,
                    boxShadow: 2,
                    mt: {
                      md: 0,
                      xs: 2,
                      sm: 1,
                    },
                  }}
                >
                  <Grid
                    onClick={() => setSelected(item)}
                    sx={{
                      alignItems: "center",
                      justifyItems: "space-between",
                      display: "flex",
                      flexDirection: "column",
                      p: 0,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: {
                          md: 100,
                          xs: 60,
                          sm: 100,
                        },
                        minwidth: 100,
                        mt: 1,
                        mb: 1,
                      }}
                      src={item.imageUrl}
                      alt="saas-dasboard-footer"
                    />

                    <Tiny
                      color="#000000"
                      fontWeight={"400"}
                      sx={{
                        pt: 0,
                        pb: 0.7,
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      {InsertDots(item.descriptions, 38)}
                    </Tiny>
                    <Box
                      sx={{
                        width: "100%",
                        paddingBottom: 0.5,
                        paddingTop: 0.2,
                        background:
                          "linear-gradient(180deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                      }}
                    >
                      <Tiny
                        color="#000000"
                        fontWeight={"500"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "center",
                          height: 40,
                        }}
                      >
                        Price: &#8377; {item?.basePrice.toFixed(2)}
                      </Tiny>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid
              sx={{
                pb: 2,
                pt: 2,
                justifyContent: "space-between",
                display: "flex",

                width: "100%",
              }}
            >
              {goldCoins.slice(3, 6).map((item: any, index: any) => (
                <Grid
                  sx={{
                    width: {
                      md: "28%",
                      xs: "30%",
                      sm: "30%",
                    },
                    cursor: "pointer",
                    background:
                      selected?.descriptions === item?.descriptions
                        ? "#FFF3DB"
                        : "#fff",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    display: "flex",
                    textAlign: "center",
                    borderRadius: 2,
                    boxShadow: 2,
                    mt: {
                      md: 0,
                      xs: 2,
                      sm: 1,
                    },
                  }}
                >
                  <Grid
                    onClick={() => setSelected(item)}
                    sx={{
                      alignItems: "center",
                      justifyItems: "space-between",
                      display: "flex",
                      flexDirection: "column",
                      p: 0,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: {
                          md: 100,
                          xs: 60,
                          sm: 100,
                        },
                        minwidth: 100,
                        mt: 1,
                        mb: 1,
                      }}
                      src={item.imageUrl}
                      alt="saas-dasboard-footer"
                    />

                    <Tiny
                      color="#000000"
                      fontWeight={"400"}
                      sx={{
                        pt: 0.7,
                        pb: 0.7,
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      {InsertDots(item.descriptions, 38)}
                    </Tiny>
                    <Box
                      sx={{
                        width: "100%",
                        paddingBottom: 0.5,
                        paddingTop: 0.2,
                        background:
                          "linear-gradient(180deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                      }}
                    >
                      <Tiny
                        color="#000000"
                        fontWeight={"400"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "center",
                          height: 40,
                        }}
                      >
                        Price: &#8377; {item?.basePrice.toFixed(2)}
                      </Tiny>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid
              sx={{
                pb: 2,
                pt: 2,
                justifyContent: "space-between",
                display: "flex",

                width: "100%",
              }}
            >
              {goldCoins.slice(6, 20).map((item: any, index: any) => (
                <Grid
                  sx={{
                    width: {
                      md: "28%",
                      xs: "30%",
                    },
                    cursor: "pointer",
                    background:
                      selected?.descriptions === item?.descriptions
                        ? "#FFF3DB"
                        : "#fff",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    textAlign: "center",
                    display: "flex",
                    borderRadius: 2,
                    boxShadow: 2,
                    mt: {
                      md: 0,
                      xs: 2,
                      sm: 1,
                    },
                  }}
                >
                  <Grid
                    onClick={() => setSelected(item)}
                    sx={{
                      alignItems: "center",
                      justifyItems: "space-between",
                      display: "flex",
                      flexDirection: "column",
                      p: 0,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: {
                          md: 100,
                          xs: 60,
                          sm: 100,
                        },
                        minwidth: 100,
                        mt: 1,
                        mb: 1,
                      }}
                      src={item.imageUrl}
                      alt="saas-dasboard-footer"
                    />
                    <Tiny
                      color="#000000"
                      fontWeight={"400"}
                      sx={{
                        pt: 0.7,
                        pb: 0.7,
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      {InsertDots(item.descriptions, 33)}
                    </Tiny>
                    <Box
                      sx={{
                        width: "100%",
                        paddingBottom: 0.5,
                        paddingTop: 0.2,
                        background:
                          "linear-gradient(180deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                      }}
                    >
                      <Tiny
                        color="#000000"
                        fontWeight={"400"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "center",
                          height: 40,
                        }}
                      >
                        Price: &#8377; {item?.basePrice.toFixed(2)}
                      </Tiny>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {selected ? (
            <Grid
              xs={12}
              md={7}
              sx={{
                pb: 5,
                pt: 2,
                justifyContent: "center",
                ml: { xs: 0, md: 4, sm: 4 },
                width: {
                  md: "60%",
                  xs: "100%",
                },
                display: "flex",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  background: "#fff",
                  alignItems: "center",
                  flexDirection: {
                    md: "row",
                    xs: "column",
                  },
                  display: "flex",
                  borderRadius: 2,
                  boxShadow: 2,
                  mt: {
                    md: 0,
                    xs: 2,
                    sm: 1,
                  },
                  height: {
                    md: 280,
                  },
                  p: 2,
                }}
              >
                <Box
                  component="img"
                  sx={{
                    height: 180,
                    minwidth: 180,
                    mt: 0.5,
                  }}
                  src={selected?.imageUrl}
                  alt="saas-dasboard-footer"
                />
                <Box
                  sx={{
                    width: {
                      md: "100%",
                      xs: "100%",
                    },
                    flexDirection: "column",
                    display: "flex",
                    borderRadius: 2,
                    mt: {
                      md: 0,
                      xs: 2,
                      sm: 1,
                    },
                    p: 1,
                  }}
                >
                  <H3
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      textAlign: "left",
                    }}
                  >
                    {selected?.descriptions}
                  </H3>
                  <Box
                    sx={{
                      borderRadius: 2,
                      flexDirection: "row",
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 0.5,
                      mb: 1,
                      width: "100%",
                    }}
                  >
                    <Small
                      sx={{
                        textAlign: "left",
                        width: {
                          md: "50%",
                          xs: "100%",
                        },
                        mt: 0.4,
                        // fontFamily: "'Poppins', sans-serif",
                        fontSize: 14,
                      }}
                      fontWeight={"700"}
                      color="#0C0C0C"
                    >
                      <Small
                        sx={{
                          textAlign: "left",
                          width: {
                            md: "50%",
                            xs: "100%",
                          },
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 14,
                        }}
                        fontWeight={"600"}
                        color="#0C0C0C"
                      >
                        Price:
                      </Small>{" "}
                      ₹
                      <Small
                        sx={{
                          textAlign: "left",
                          width: {
                            md: "50%",
                            xs: "100%",
                          },
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 14,
                        }}
                        fontWeight={"600"}
                        color="#0C0C0C"
                      >
                        {selected?.basePrice}
                      </Small>
                    </Small>
                    <Small
                      sx={{
                        textAlign: "right",
                        width: {
                          md: "50%",
                          xs: "100%",
                        },
                        mt: 0.4,
                        mr: 3,
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: 12,
                      }}
                      fontWeight={"400"}
                      color="#0C0C0C"
                    >
                      Model No: {selected?.productCode}
                    </Small>
                  </Box>
                  <Small
                    color="#858585"
                    fontWeight={"400"}
                    sx={{
                      pt: 0.1,
                      pb: 0.7,
                      width: "100%",
                      textAlign: {
                        md: "left",
                        xs: "center",
                      },
                      fontSize: 12,
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {selected?.descriptions.includes("Ganesha")
                      ? "This Lord Ganesha Gold Coin beautifully showcases the divine charm and exquisite craftsmanship with its intricately carved image of Lord Ganesha."
                      : "Grace and craftsmanship unite seamlessly in this stunning Goddess Lakshmi Gold Coin. The coin features an artfully carved image of Goddess Lakshmi, symbolizing prosperity and beauty."}
                  </Small>

                  <Box
                    sx={{
                      flexDirection: {
                        md: "row",
                        xs: "column",
                        sm: "column",
                      },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CheckOutlinedIcon
                        style={{
                          color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                        }}
                      />
                      <Small
                        color="#858585"
                        fontWeight={"400"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "left",
                          fontSize: 12,
                          fontFamily: "'Poppins', sans-serif",
                          ml: 1,
                        }}
                      >
                        Certified Gold Coins
                      </Small>
                    </Box>
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ShoppingCartOutlinedIcon
                        style={{
                          color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                        }}
                      />
                      <Small
                        color="#858585"
                        fontWeight={"400"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "left",
                          fontSize: 12,
                          fontFamily: "'Poppins', sans-serif",
                          ml: 1,
                        }}
                      >
                        Secured Delivery
                      </Small>
                    </Box>
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <SettingsBackupRestoreOutlinedIcon
                        style={{
                          color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                        }}
                      />
                      <Small
                        color="#858585"
                        fontWeight={"400"}
                        sx={{
                          width: "100%",
                          textAlign: "left",
                          fontSize: 12,
                          fontFamily: "'Poppins', sans-serif",
                          ml: 1,
                        }}
                      >
                        No returns on coins
                      </Small>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      onClick={onPress}
                      disableElevation
                      disableRipple
                      size="medium"
                      sx={{
                        background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                        color: "#fff",
                        width: "50%",
                        mb: 1,
                        mt: 1.5,
                        textTransform: "none",
                      }}
                    >
                      Buy Now
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ) : (
            <Grid
              xs={12}
              md={7}
              sx={{
                pb: 5,
                pt: 2,
                justifyContent: "center",

                width: {
                  md: "60%",
                  xs: "100%",
                },
                ml: { xs: 0, md: 4, sm: 4 },
                display: { xs: "none", md: "flex", sm: "flex" },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  background: "#fff",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: {
                    md: "row",
                    xs: "column",
                  },
                  paddingX: 5,
                  paddingY: 15,
                  display: "flex",
                  borderRadius: 2,
                  boxShadow: 2,
                  mt: {
                    md: 0,
                    xs: 2,
                    sm: 1,
                  },
                  height: {
                    md: 280,
                  },
                  p: 2,
                }}
              >
                <Grid
                  textAlign="center"
                  justifyContent="center"
                  sx={{ width: { md: "50%", sm: "90%", xs: "90%" } }}
                >
                  <H1
                    sx={{
                      background: "blue",
                      textAlign: "center",
                      alignSelf: "center",
                    }}
                    fontWeight={300}
                    color="#989898"
                  >
                    Product detail will be displayed here
                  </H1>
                </Grid>
              </Box>
            </Grid>
          )}
        </Grid>

        {/* small devices */}
        <Grid
          sx={{
            display: { xs: "flex", sm: "none", md: "none" },
            flexDirection: {
              md: "row",
              xs: "column",
            },
            width: "100%",
          }}
        >
          <Grid
            xs={12}
            md={5}
            sx={{
              display: "flex",
              flexDirection: "column",
              width: {
                md: "50%",
                xs: "100%",
              },
            }}
          >
            <Grid
              sx={{
                pt: 2,
                justifyContent: "space-around ",
                display: "flex",

                width: "100%",
              }}
            >
              {goldCoins.slice(0, 2).map((item: any, index: any) => (
                <Grid
                  sx={{
                    width: "40%",
                    cursor: "pointer",
                    background:
                      selected?.descriptions === item?.descriptions
                        ? "#FFF3DB"
                        : "#fff",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    display: "flex",
                    textAlign: "center",
                    borderRadius: 2,
                    boxShadow: 2,
                    mt: {
                      md: 0,
                      xs: 2,
                      sm: 1,
                    },
                  }}
                >
                  <Grid
                    key={item.id}
                    item
                    ref={(ref: any) => setRef(item, ref)}
                    onClick={() => handleGridClick(item)}
                    sx={{
                      alignItems: "center",
                      justifyItems: "space-between",
                      display: "flex",
                      flexDirection: "column",
                      p: 0,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: {
                          md: 100,
                          xs: 100,
                          sm: 100,
                        },
                        minwidth: 100,
                        mt: 1,
                        mb: 1,
                      }}
                      src={item.imageUrl}
                      alt="saas-dasboard-footer"
                    />

                    <Tiny
                      color="#000000"
                      fontWeight={"400"}
                      sx={{
                        pt: 0,
                        pb: 0.7,
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      {InsertDots(item.descriptions, 38)}
                    </Tiny>
                    <Box
                      sx={{
                        width: "100%",
                        paddingBottom: 0.5,
                        paddingTop: 0.2,
                        background:
                          "linear-gradient(180deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                      }}
                    >
                      <Tiny
                        color="#000000"
                        fontWeight={"500"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "center",
                          height: 40,
                        }}
                      >
                        Price: &#8377; {item?.basePrice.toFixed(2)}
                      </Tiny>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid
              sx={{
                justifyContent: "space-around",
                display: "flex",

                width: "100%",
              }}
            >
              {goldCoins.slice(2, 4).map((item: any, index: any) => (
                <Grid
                  sx={{
                    width: "40%",
                    cursor: "pointer",
                    background:
                      selected?.descriptions === item?.descriptions
                        ? "#FFF3DB"
                        : "#fff",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    display: "flex",
                    textAlign: "center",
                    borderRadius: 2,
                    boxShadow: 2,
                    mt: {
                      md: 0,
                      xs: 2,
                      sm: 1,
                    },
                  }}
                >
                  <Grid
                    key={item.id}
                    item
                    ref={(ref: any) => setRef(item, ref)}
                    onClick={() => handleGridClick(item)}
                    // onClick={() => setSelected(item)}
                    sx={{
                      alignItems: "center",
                      justifyItems: "space-between",
                      display: "flex",
                      flexDirection: "column",
                      p: 0,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: 100,
                        minwidth: 100,
                        mt: 1,
                        mb: 1,
                      }}
                      src={item.imageUrl}
                      alt="saas-dasboard-footer"
                    />

                    <Tiny
                      color="#000000"
                      fontWeight={"400"}
                      sx={{
                        pt: 0.7,
                        pb: 0.7,
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      {InsertDots(item.descriptions, 38)}
                    </Tiny>
                    <Box
                      sx={{
                        width: "100%",
                        paddingBottom: 0.5,
                        paddingTop: 0.2,
                        background:
                          "linear-gradient(180deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                      }}
                    >
                      <Tiny
                        color="#000000"
                        fontWeight={"400"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "center",
                          height: 40,
                        }}
                      >
                        Price: &#8377; {item?.basePrice.toFixed(2)}
                      </Tiny>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid
              sx={{
                justifyContent: "space-around",
                display: "flex",

                width: "100%",
              }}
            >
              {goldCoins.slice(4, 6).map((item: any, index: any) => (
                <Grid
                  sx={{
                    width: "40%",
                    cursor: "pointer",
                    background:
                      selected?.descriptions === item?.descriptions
                        ? "#FFF3DB"
                        : "#fff",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    textAlign: "center",
                    display: "flex",
                    borderRadius: 2,
                    boxShadow: 2,
                    mt: {
                      md: 0,
                      xs: 2,
                      sm: 1,
                    },
                  }}
                >
                  <Grid
                    key={item.id}
                    item
                    ref={(ref: any) => setRef(item, ref)}
                    onClick={() => handleGridClick(item)}
                    // onClick={() => setSelected(item)}
                    sx={{
                      alignItems: "center",
                      justifyItems: "space-between",
                      display: "flex",
                      flexDirection: "column",
                      p: 0,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: 100,
                        minwidth: 100,
                        mt: 1,
                        mb: 1,
                      }}
                      src={item.imageUrl}
                      alt="saas-dasboard-footer"
                    />
                    <Tiny
                      color="#000000"
                      fontWeight={"400"}
                      sx={{
                        pt: 0.7,
                        pb: 0.7,
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      {InsertDots(item.descriptions, 33)}
                    </Tiny>
                    <Box
                      sx={{
                        width: "100%",
                        paddingBottom: 0.5,
                        paddingTop: 0.2,
                        background:
                          "linear-gradient(180deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                      }}
                    >
                      <Tiny
                        color="#000000"
                        fontWeight={"400"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "center",
                          height: 40,
                        }}
                      >
                        Price: &#8377; {item?.basePrice.toFixed(2)}
                      </Tiny>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid
              sx={{
                justifyContent: "space-around",
                display: "flex",

                width: "100%",
              }}
            >
              {goldCoins.slice(6, 8).map((item: any, index: any) => (
                <Grid
                  sx={{
                    width: "40%",
                    cursor: "pointer",
                    background:
                      selected?.descriptions === item?.descriptions
                        ? "#FFF3DB"
                        : "#fff",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    textAlign: "center",
                    display: "flex",
                    borderRadius: 2,
                    boxShadow: 2,
                    mt: {
                      md: 0,
                      xs: 2,
                      sm: 1,
                    },
                  }}
                >
                  <Grid
                    key={item.id}
                    item
                    ref={(ref: any) => setRef(item, ref)}
                    onClick={() => handleGridClick(item)}
                    sx={{
                      alignItems: "center",
                      justifyItems: "space-between",
                      display: "flex",
                      flexDirection: "column",
                      p: 0,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: 100,
                        minwidth: 100,
                        mt: 1,
                        mb: 1,
                      }}
                      src={item.imageUrl}
                      alt="saas-dasboard-footer"
                    />
                    <Tiny
                      color="#000000"
                      fontWeight={"400"}
                      sx={{
                        pt: 0.7,
                        pb: 0.7,
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      {InsertDots(item.descriptions, 33)}
                    </Tiny>
                    <Box
                      sx={{
                        width: "100%",
                        paddingBottom: 0.5,
                        paddingTop: 0.2,
                        background:
                          "linear-gradient(180deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                      }}
                    >
                      <Tiny
                        color="#000000"
                        fontWeight={"400"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "center",
                          height: 40,
                        }}
                      >
                        Price: &#8377; {item?.basePrice.toFixed(2)}
                      </Tiny>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {selected ? (
            <Grid
              xs={12}
              md={7}
              ref={selectedGridRef}
              sx={{
                pb: 5,
                pt: 2,
                justifyContent: "center",
                ml: { xs: 0, md: 4, sm: 4 },
                width: {
                  md: "60%",
                  xs: "100%",
                },
                display: "flex",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  background: "#fff",
                  alignItems: "center",
                  flexDirection: {
                    md: "row",
                    xs: "column",
                  },
                  display: "flex",
                  borderRadius: 2,
                  boxShadow: 2,
                  mt: {
                    md: 0,
                    xs: 2,
                    sm: 1,
                  },
                  height: {
                    md: 280,
                  },
                  p: 2,
                }}
              >
                <Box
                  component="img"
                  sx={{
                    height: 180,
                    minwidth: 180,
                    mt: 0.5,
                  }}
                  src={selected?.imageUrl}
                  alt="saas-dasboard-footer"
                />
                <Box
                  sx={{
                    width: {
                      md: "100%",
                      xs: "100%",
                    },
                    flexDirection: "column",
                    display: "flex",
                    borderRadius: 2,
                    mt: {
                      md: 0,
                      xs: 2,
                      sm: 1,
                    },
                    p: 1,
                  }}
                >
                  <H3
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      textAlign: "left",
                    }}
                  >
                    {selected?.descriptions}
                  </H3>
                  <Box
                    sx={{
                      borderRadius: 2,
                      flexDirection: "row",
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 0.5,
                      mb: 1,
                      width: "100%",
                    }}
                  >
                    <Small
                      sx={{
                        textAlign: "left",
                        width: {
                          md: "50%",
                          xs: "100%",
                        },
                        mt: 0.4,
                        // fontFamily: "'Poppins', sans-serif",
                        fontSize: 14,
                      }}
                      fontWeight={"700"}
                      color="#0C0C0C"
                    >
                      <Small
                        sx={{
                          textAlign: "left",
                          width: {
                            md: "50%",
                            xs: "100%",
                          },
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 14,
                        }}
                        fontWeight={"600"}
                        color="#0C0C0C"
                      >
                        Price:
                      </Small>{" "}
                      ₹
                      <Small
                        sx={{
                          textAlign: "left",
                          width: {
                            md: "50%",
                            xs: "100%",
                          },
                          mt: 0.4,
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: 14,
                        }}
                        fontWeight={"600"}
                        color="#0C0C0C"
                      >
                        {selected?.basePrice}
                      </Small>
                    </Small>
                    <Small
                      sx={{
                        textAlign: "right",
                        width: {
                          md: "50%",
                          xs: "100%",
                        },
                        mt: 0.4,
                        mr: 3,
                        fontFamily: "'Poppins', sans-serif",
                        fontSize: 12,
                      }}
                      fontWeight={"400"}
                      color="#0C0C0C"
                    >
                      Model No: {selected?.productCode}
                    </Small>
                  </Box>
                  <Small
                    color="#858585"
                    fontWeight={"400"}
                    sx={{
                      pt: 0.1,
                      pb: 0.7,
                      width: "100%",
                      textAlign: {
                        md: "left",
                        xs: "center",
                      },
                      fontSize: 12,
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {selected?.descriptions.includes("Ganesha")
                      ? "This Lord Ganesha Gold Coin beautifully showcases the divine charm and exquisite craftsmanship with its intricately carved image of Lord Ganesha."
                      : "Grace and craftsmanship unite seamlessly in this stunning Goddess Lakshmi Gold Coin. The coin features an artfully carved image of Goddess Lakshmi, symbolizing prosperity and beauty."}
                  </Small>

                  <Box
                    sx={{
                      flexDirection: {
                        md: "row",
                        xs: "column",
                        sm: "column",
                      },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CheckOutlinedIcon
                        style={{
                          color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                        }}
                      />
                      <Small
                        color="#858585"
                        fontWeight={"400"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "left",
                          fontSize: 12,
                          fontFamily: "'Poppins', sans-serif",
                          ml: 1,
                        }}
                      >
                        Certified Gold Coins
                      </Small>
                    </Box>
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ShoppingCartOutlinedIcon
                        style={{
                          color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                        }}
                      />
                      <Small
                        color="#858585"
                        fontWeight={"400"}
                        sx={{
                          pt: 0.7,
                          pb: 0.7,
                          width: "100%",
                          textAlign: "left",
                          fontSize: 12,
                          fontFamily: "'Poppins', sans-serif",
                          ml: 1,
                        }}
                      >
                        Secured Delivery
                      </Small>
                    </Box>
                    <Box
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <SettingsBackupRestoreOutlinedIcon
                        style={{
                          color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                        }}
                      />
                      <Small
                        color="#858585"
                        fontWeight={"400"}
                        sx={{
                          width: "100%",
                          textAlign: "left",
                          fontSize: 12,
                          fontFamily: "'Poppins', sans-serif",
                          ml: 1,
                        }}
                      >
                        No returns on coins
                      </Small>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      flexDirection: "row",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      onClick={onPress}
                      disableElevation
                      disableRipple
                      size="medium"
                      sx={{
                        background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                        color: "#fff",
                        width: "50%",
                        mb: 1,
                        mt: 1.5,
                        textTransform: "none",
                      }}
                    >
                      Buy Now
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ) : (
            <Grid
              xs={12}
              md={7}
              sx={{
                pb: 5,
                pt: 2,
                justifyContent: "center",

                width: {
                  md: "60%",
                  xs: "100%",
                },
                ml: { xs: 0, md: 4, sm: 4 },
                display: { xs: "none", md: "flex", sm: "flex" },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  background: "#fff",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: {
                    md: "row",
                    xs: "column",
                  },
                  paddingX: 5,
                  paddingY: 15,
                  display: "flex",
                  borderRadius: 2,
                  boxShadow: 2,
                  mt: {
                    md: 0,
                    xs: 2,
                    sm: 1,
                  },
                  height: {
                    md: 280,
                  },
                  p: 2,
                }}
              >
                <Grid
                  textAlign="center"
                  justifyContent="center"
                  sx={{ width: { md: "50%", sm: "90%", xs: "90%" } }}
                >
                  <H1
                    sx={{
                      background: "blue",
                      textAlign: "center",
                      alignSelf: "center",
                    }}
                    fontWeight={300}
                    color="#989898"
                  >
                    Product detail will be displayed here
                  </H1>
                </Grid>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default GoldCoin;
